type FirestoreTimestampLike = {
  toDate: () => unknown;
};

export const normalizeProductFeedbackTimestamp = (value: unknown): string | null => {
  try {
    const date =
      typeof value === 'string'
        ? new Date(value)
        : value &&
            typeof value === 'object' &&
            typeof (value as Partial<FirestoreTimestampLike>).toDate === 'function'
          ? (value as FirestoreTimestampLike).toDate()
          : null;

    if (!(date instanceof Date) || !Number.isFinite(date.getTime())) {
      return null;
    }

    return date.toISOString();
  } catch {
    return null;
  }
};
